import { render, staticRenderFns } from "./UrlPreview.vue?vue&type=template&id=56c4377d&"
import script from "./UrlPreview.vue?vue&type=script&lang=ts&"
export * from "./UrlPreview.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports